import { motion } from 'framer-motion';
import { Typography, Box } from '@mui/material';
import { Surface } from '../../../components/primitives';

const MotionSurface = motion(Surface);

export default function ChartSection({ title, subtitle, takeaway, children, delay = 0, id }) {
    return (
        <MotionSurface
            id={id}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-50px' }}
            transition={{ delay: Math.min(delay, 0.2), duration: 0.4 }}
            padding={3}
            sx={{ mb: 3, scrollMarginTop: '80px' }}
        >
            <Typography variant="h3" sx={{ color: 'text.primary', mb: 0.5 }}>
                {title}
            </Typography>
            {subtitle && (
                <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
                    {subtitle}
                </Typography>
            )}
            <Box>{children}</Box>
            {takeaway && (
                <Typography variant="body2" sx={{ mt: 2, px: 1, py: 1, color: 'text.secondary', fontStyle: 'italic', borderLeft: t => '3px solid ' + t.palette.primary.main }}>
                    {takeaway}
                </Typography>
            )}
        </MotionSurface>
    );
}
